export default {
  isLoaded: state => state.loaded
}